<template>
  <router-view />
</template>
<script lang="ts">
import { Vue } from "vue-class-component";
export default class App extends Vue {
  mounted() {
    console.log("Version 1.0.0");
  }
}
</script>
<style></style>
